<template>
  <v-container fluid fill-height>
    <v-layout column align-start justify-start>
      <h2 class="headline">Ento Chart!</h2>
      <v-divider></v-divider>

      <!-- <v-container grid-list-xl>
                <v-layout row wrap>
                    <v-flex xs6>
                        
                    </v-flex>
                </v-layout>
            </v-container> -->

      <bar-chart
        v-if="chartData.labels.length"
        :chartData="chartData"
        :options="options"
        style="width: 100%;"
      ></bar-chart>

      <b-btn @click="fillData()">Randomize</b-btn>
    </v-layout>
  </v-container>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import _ from "lodash";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import BarChart from "@/components/charts/BarChart.vue";

export default {
  mixins: {
    DashboardBaseTemplate
  },
  components: {
    BarChart
  },
  data() {
    return {
      chartData: {
        labels: [],
        datasets: [
          {
            label: "Abdominal Status",
            backgroundColor: "#f87979",
            data: []
          },
          {
            label: "Another",
            backgroundColor: "#ccc",
            data: []
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      }
    };
  },
  computed: {},
  mounted: function() {
    this.fillData();
  },
  methods: {
    fillData() {
      HTTP.get("/kenya/chart").then(response => {
        var counts = {};
        response.data.map(item => {
          if (item.abdominal_status) {
            if (!(item.abdominal_status in counts)) {
              counts[item.abdominal_status] = 0;
            }
            counts[item.abdominal_status] +=
              Math.floor(Math.random() * (50 - 5 + 1)) + 5;
          }
        });

        var labels = [];
        var data = [];

        _.each(counts, function(count, key) {
          labels.push(key);
          data.push(count);
        });

        this.chartData = {
          labels: labels,
          datasets: [
            {
              label: "Abdominal Status",
              backgroundColor: "#f87979",
              data: data
            },
            {
              label: "Another",
              backgroundColor: "#ccc",
              data: data
            }
          ]
        };
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    },

    clearData() {
      this.chartData = {
        labels: [],
        datasets: [
          {
            label: "Abdominal Status",
            backgroundColor: "#f87979",
            data: []
          },
          {
            label: "Another",
            backgroundColor: "#ccc",
            data: []
          }
        ]
      };
    }
  }
};
</script>

<style scoped>
bar-chart {
  width: 100%;
}
</style>
